module.exports = __webpack_public_path__ + "static/media/home-left.8aca2583.png";